import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useToasts } from 'react-toast-notifications';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box, Button, Heading } from 'rebass';
import { Input, Label, Textarea } from '@rebass/forms';
import people_service from 'services/people';
import services from 'services/services';
import helpers from 'utils/helpers';
import config from 'config';
import cloneDeep from 'lodash/cloneDeep';
import ReactModal from 'react-modal';
import { FiEdit, FiXCircle, FiFileText } from 'react-icons/fi';
import moment from 'moment-timezone';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import ParticipantsPageSubNav from 'containers/ParticipantsPage/ParticipantsPageSubNav';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import { ReactFormBuilder } from 'components/ReactFormBuilder';
import ScreenerTranslationComponent from 'components/ScreenerTranslationComponent';
import NiceModal from 'components/NiceModal';
import { ActionButton } from 'components/Button/ActionButton';

let saveDelay;

function PanelSignupFormsList(props) {
    const [ panelForms, setPanelForms ] = useState([]);
    const [ showModal, setShowModal ] = useState(false);
    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(true);
    const { addToast } = useToasts();

    useEffect(() => {
        xhrGetPanelSignupForms();
    }, []);

    function xhrGetPanelSignupForms() {
        people_service
            .getPanelSignupForms()
            .then(st => {
                setPanelForms(st);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }


    function saveFormXHR(e) {

        e.preventDefault();

        setIsSubmitting(true);

        const title = document.getElementById('new-form-title').value;
        const description = document.getElementById('new-form-description').value;

        people_service
            .createPanelSignupForm(title, description)
            .then(form_xhr => {
                addToast('Created', {
                    appearance: 'success',
                    autoDismiss: true
                });

                props.history.push(`/panel-signup/${form_xhr.id}`);
            })
            .catch(error => {
                setIsSubmitting(false);
                const errorText = services.parseXhrErrors(error);
                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    return (
        <Flex style={{ width: '100%' }}>
            <AppPageWrapper>
                <Helmet>
                    <title>Signup Forms</title>
                </Helmet>

                <AppPageSubnav>
                    <ParticipantsPageSubNav/>
                </AppPageSubnav>

                <AppPageWrapperSectionHeader className='experience'>
                    <Box>
                        <H1>Panelist Sign-up Forms</H1>

                        <Box className='experience-description'>
                            <Box mb={2}>
                                These forms act like screeners, and result in panel signups.<br/>
                                You can also let panelists create a login with these links:&nbsp;
                                <a href={`${config.getAccountPrefixUrl(props.auth.account)}/panelist/${props.auth.account.uuid}/signup`} target="_blank">Sign Up</a> and&nbsp;
                                <a href={`${config.getAccountPrefixUrl(props.auth.account)}/panelist/${props.auth.account.uuid}/login`} target="_blank">Log In</a>.
                            </Box>
                        </Box>
                    </Box>

                    <Box mt={2}>
                        <ActionButton
                            title="New Form"
                            action={() => setShowModal(true)}
                            keyLabel="N"
                            mr={0}
                        />
                    </Box>
                </AppPageWrapperSectionHeader>
                <AppPageWrapperSectionBody>
                    <Box mx={3} my={3} width="100%">

                        <ItemWrapper className='header-row'>
                            <Box width={5/8}>Title & Description</Box>
                            <Box width={1/8}>Show in profile?</Box>
                            <Box width={1/8}>Created</Box>
                            <Box width={1/8} sx={{textAlign: 'right'}}>Actions</Box>
                        </ItemWrapper>
                        {!isLoading && panelForms && panelForms.length == 0 && (
                            <Box mt={4} mx={3}>No results, create your first Signup Form!</Box>
                        )}
                        {panelForms.map(pf => {
                            return <Link to={`/panel-signup/${pf.id}`}>
                                <ItemWrapper key={pf.id}>
                                    <Box width={5/8}>
                                        <Link to={`/panel-signup/${pf.id}`} className="muted">{pf.title ? pf.title : '(no title)'}</Link>
                                        <Box style={{ width: '100%' }} mt={1} className='ellipsis text-seconday fs-12'>
                                            {pf.description}
                                        </Box>
                                    </Box>
                                    <Box width={1/8} className='text-primary'>
                                        {pf.show_in_profile ? 'Yes' : 'No'}
                                    </Box>
                                    <Box width={1/8} className='text-primary'>
                                        {moment
                                            .utc(pf.created_at)
                                            .format('MMMM D, YYYY')}
                                    </Box>
                                    <Box width={1/8} style={{textAlign: 'right'}}>
                                        {/*<Link to={`/panel-signup/${pf.id}`}><Button type='button' variant='secondary-gray' mr={2} ><FiEdit /> Edit</Button></Link>*/}
                                        <Button type='button' variant='secondary-gray' className='secondary-icon' onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if(confirm('Are you sure?')) {
                                                people_service.deletePanelSignupForm(pf.id)
                                                    .then(() => {
                                                        xhrGetPanelSignupForms();
                                                    });
                                            }
                                        }}><FiXCircle /></Button>
                                    </Box>
                                </ItemWrapper>
                            </Link>;
                        })}
                    </Box>

                    <NiceModal
                        isOpen={showModal}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => setShowModal(false)}
                        title={`Create a new form`}
                    >
                            <form onSubmit={saveFormXHR}>


                                <Label htmlFor="title">
                                    Title
                                </Label>

                                <Input
                                    id="new-form-title"
                                    type="text"
                                    name="title"
                                    placeholder="Title"
                                    autoComplete="off"
                                    required
                                    autoFocus
                                />

                                <Label mt={3} htmlFor="description">
                                    Description
                                </Label>

                                <Textarea
                                    id="new-form-description"
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                />

                                <Box className='modal-actions'>
                                    <Button type="button" variant="secondary-gray" mr={3} onClick={() => setShowModal(false)}>Cancel</Button>
                                    <Button mr={0} type="submit" variant="primary" className="modal-primary" disabled={isSubmitting}>
                                        Create form
                                    </Button>
                                </Box>
                            </form>
                    </NiceModal>
                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        </Flex>
    );
}

export default PanelSignupFormsList;
